import React from 'react';
import { Image } from 'react-native';
import type { CompanyProps, CompetitionProps, CompetitionRecordProps, CompetitionResultProps, CompetitionResultTypeProps, CompetitionTypeProps, MyPlayerProps, PublicPlayerProps } from '../../types';
import { Icons } from '../../Components';
import moment from 'moment-mini';
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';
import { CompetitionHelpers } from '../../Competition/api';

type CompetitionCardProps = {
    competition:CompetitionProps,
    player?:MyPlayerProps,
    competition_type:CompetitionTypeProps,
    competition_result?:CompetitionResultProps,
    competition_record?:CompetitionRecordProps,
    competition_result_type:CompetitionResultTypeProps,
    company?:CompanyProps,
    admin?:PublicPlayerProps,
    pacer?:PublicPlayerProps,
    onCompetitionSelect:(c:CompetitionProps) => void
}
const CompetitionCard = ({ competition, competition_record, player, competition_result, competition_type, company, admin, onCompetitionSelect }:CompetitionCardProps) => {
    const Colors = useColors();
    const cl = competition.market_type == 'FOR_MONEY' ? '$' : 'E'
    let current_payout = competition.ticket_revenue
    if(competition.promo_payout){ current_payout += competition.promo_payout }
    if(competition.guaranteed_payout && parseFloat(competition.guaranteed_payout as string) > current_payout){ current_payout = parseFloat(competition.guaranteed_payout as string) }

    const tickets_available = parseFloat(competition.available_tickets as string) - competition.tickets_sold
    const is_live = moment().isAfter(moment(competition.scheduled_datetime)) ? true : false
    const is_closed = competition.status == 'closed' ? true : false
    const getTypeIcon = () => {
        switch(competition_type.type){
            case 'pick':
                return <Icons.SelectorIcon size={20} color={Colors.text.h1} />
            default: return <></>
        }
    }
    
    return (
        <Button float style={{ padding:0 }} onPress={() => onCompetitionSelect(competition)}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <Image
                    source={{ uri: competition.image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:45, width:45, borderRadius:4}}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                    <Text theme='h2'>{competition.competition_name}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>{competition.competition_description}</Text>
                    <Text style={{ marginTop:3 }} theme='action'>Join Unitl {moment(competition.scheduled_datetime).format('MMM DD hh:mm a')}</Text>

                </View>
                <Text size={20} color={Colors.text.action} weight='bold'>{cl}{competition.buy_in}</Text>
            </View>
            <View type='body' style={{ padding:10 }}>
                <View type='row'>
                    
                    {tickets_available > 0 ? 
                    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        <Text size={18} color={Colors.text.h1} weight='bold'>{tickets_available}</Text>
                        <Text style={{ marginTop:3 }} theme='description'>TICKETS</Text>
                    </View>
                    :
                    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        <Text size={18} color={Colors.text.error} weight='bold'>FULL</Text>
                    </View>
                    }
                    {competition_type.type == 'pick' ?
                    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        <Text size={18} color={Colors.text.h1} weight='bold'>{competition.max_pick_count}</Text>
                        <Text style={{ marginTop:3 }} theme='description'>PICKS</Text>
                    </View>
                    :
                    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        <Text size={18} color={Colors.text.h1} weight='bold' textAlign='center'>E{competition.initial_balance}</Text>
                        <Text style={{ marginTop:3 }} size={14} color={Colors.text.h1} textAlign='center'>STARTING BALANCE</Text>
                    </View>
                    }
                    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        {getTypeIcon()}
                        <Text style={{ marginTop:3 }} theme='description'>{competition_type.type_label.toUpperCase()}</Text>
                    </View>
                </View>
            </View>
            {player && competition_result && competition_record ?
            <View type='footer' style={{ padding:10, flexDirection:'row', alignItems:'center', borderBottomWidth:1, borderColor:Colors.borders.light }}>
                <Image
                    source={{ uri: player.profile_pic }}
                    style={{ height:30, width:30, borderRadius:100 }}
                    resizeMode='contain'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>@{player.username}</Text>
                    <View transparent style={{ marginTop:3 }}>
                        {competition_type.type == 'pick' ?
                        <Text theme="description">{competition_record.wins} - {competition_record.losses} - {competition_record.draws} ({competition_record.remaining_picks} Remaining)</Text>
                        :competition_type.type == 'wager' ?
                        <Text theme="description">{competition_record.earnings.toFixed(2)} Earned ({competition_record.remaining_stakes.toFixed(2)} at risk)</Text>
                        :<></>}
                    </View>
                </View>
                <View transparent style={{ alignItems:'flex-end' }}>
                    <Text theme='h2' color={competition_result.winnings > 0 ? Colors.text.success : Colors.text.warning}>{cl}{competition_result.winnings.toFixed(2)}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{CompetitionHelpers.formatPlace(competition_result.place)} / {competition.tickets_sold}</Text>
                </View>
            </View>
            :<></>}
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                {company ?
                <Image
                    source={{ uri: company.company_image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:30, width:30, borderRadius:4}}
                    resizeMode='cover'
                />
                :admin ?
                <Image
                    source={{ uri: admin.profile_pic && admin.profile_pic != '' ? admin.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:30, width:30, borderRadius:4}}
                    resizeMode='cover'
                />
                :<></>}
                {competition.prize_override ?
                <View transparent style={{ flex:1, flexDirection:'row', alignItems:'center', marginLeft:10 }}>
                    <View transparent style={{ flex:1, marginRight:10}}>
                        <Text size={12} weight='bold' color={Colors.text.h1}>ADDITIONAL PRIZE</Text>
                        <Text style={{ marginTop:3 }} size={10} color={Colors.text.gold} weight='bold'>{competition.prize_override}</Text>
                    </View>
                    {competition.prize_image?.url ?
                    <Image
                        source={{ uri: competition.prize_image.url }}
                        style={{ height:30, width:30, borderRadius:4}}
                        resizeMode='cover'
                    />
                    :
                    <Icons.AwardRibbonIcon size={24} color={Colors.text.gold} />
                    }
                </View>
                :
                <View transparent style={{ flex:1, flexDirection:'row', alignItems:'center' }}>
                    <View transparent style={{ flex:1, marginLeft:20, marginRight:20 }}>
                        <Text theme='h2'>{is_closed ? 'TOTAL PAID OUT': 'CURRENT PAYOUT'}</Text>
                        {is_closed ?
                        <Text style={{ marginTop:3 }} color={Colors.text.gold} weight='bold' size={12}>COMPLETED</Text>
                        :
                        is_live ? 
                        <Text style={{ marginTop:3 }} color={Colors.text.error} weight='bold' size={12}>IN PROGRESS</Text>
                        :
                        <Text style={{ marginTop:3 }} theme='light'>Join Until {moment(competition.scheduled_datetime).format('ddd hh:mm a')}</Text>
                        }
                    </View>
                    <Text color={Colors.text.success} size={20} weight='bold'>{cl}{current_payout.toFixed(2)}</Text>
                </View>
                }
            </View>
        </Button> 
    )
}

export default CompetitionCard